import { InjectionToken } from '@angular/core';

export const JWT_STORAGE_KEY_CONFIGURATION_TOKEN = new InjectionToken<string>(
  `Configure Token Key`
);
